<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('tipoendereco') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t('vendas') : $t('agro')
                                    }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: `${abrev}-tipoendereco` })">{{
                                        $t('tipoendereco')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ $route.params.id ? $route.params.id : $t('novo') }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `${abrev}-tipoendereco` })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!integracao && !isUpdate && permissao.create) ||
                                (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(9)"
                                ref="idErpInput"
                                v-model="tipoEndereco.idtipoenderecoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!tipoEndereco.idtipoenderecoerp"
                                tooltipLabel="cod-ref"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-9">
                            <v-input
                                :id="generateId(1)"
                                ref="nomeInput"
                                v-model="tipoEndereco.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!tipoEndereco.descricao"
                                uppercase
                                tooltipLabel="informacao-descricao-tipoendereco"
                                tooltipSize="is-small"
                                title="descricao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                :required="true"
                                :disabled="cantEdit"
                            />
                        </div>

                        <div class="column is-6">
                            <vss-select
                                :id="generateId(2)"
                                ref="tipoSelect"
                                :searchable="false"
                                :options="tipoSelect"
                                v-model="tipoSelected"
                                class="no-clear"
                                :mlLabels="true"
                                tooltipLabel="informacao-tipo-endereco"
                                tooltipSize="is-small"
                                title="tipo"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                :disabled="cantEdit"
                            />
                        </div>

                        <div class="column is-6">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="tipoEndereco.id == null || cantEdit"
                                tooltipLabel="informacao-situacao-tipoendereco"
                                tooltipSize="is-small"
                                title="situacao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoEnderecoService from '@/services/vendas/TipoEnderecoService';
import TipoEnderecoValidation from '@/services/validations/vendas/TipoEnderecoValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('TIPOENDERECO'),
            service: new TipoEnderecoService(this.$http, this.$router),
            validation: new TipoEnderecoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            tipoEndereco: {
                id: null,
                idtipoenderecoerp: null,
                descricao: null,
                situacao: null,
                tipo: null,
            },
            isUpdate: false,
            situacaoSelect: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacaoSelected: { label: 'ativo', id: 1 },
            tipoSelect: [
                { label: 'entrega', id: 'E' },
                { label: 'cobranca', id: 'C' },
            ],
            tipoSelected: { label: 'entrega', id: 'E' },
            isMobile: false,
            cantEdit: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'clientes', 'ven-tipoendereco');
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'clientes', 'agro-tipoendereco');
        }

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'tipoendereco' },
            });
        } else {
            if (this.$route.params.id) {
                this.cantEdit = this.integracao || !this.permissao.update;
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.findTE(id)
                .then((value) => {
                    this.tipoEndereco = Object.assign(value.content);
                    this.situacaoSelected = this.situacaoSelect.filter(
                        (f) => f.id == this.tipoEndereco.situacao
                    )[0];
                    this.tipoSelected = this.tipoSelect.filter(
                        (f) => f.id == this.tipoEndereco.tipo
                    )[0];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        findTE(id) {
            if (this.isVenda) return this.service.findVendas(id);
            else return this.service.findAgro(id);
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.tipoEndereco, this.$refs)) {
                let tipoEnderecoTemp = Object.assign({}, this.tipoEndereco);
                tipoEnderecoTemp = this.mapTosave(tipoEnderecoTemp);
                tipoEnderecoTemp.situacao = this.situacaoSelected.id;
                tipoEnderecoTemp.tipo = this.tipoSelected.id;

                this.isSaving = true;
                this.saveTE(tipoEnderecoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-tipoendereco';
                            if (this.tipoEndereco.id != null) {
                                msg = 'msg-edit-tipoendereco';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToList();
                        } else {
                            if (this.existDisc(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: tipoEnderecoTemp.idtipoenderecoerp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        saveTE(tipoEndereco) {
            if (this.isVenda) return this.service.saveVendas(tipoEndereco);
            else return this.service.saveAgro(tipoEndereco);
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.descricao,
            };
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.abrev}-tipoendereco`,
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
